import { ComponentRef, Injectable, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, finalize, Subscription } from 'rxjs';
import { IGenericAlert } from 'src/app/model/generic-messages.model';
import { GenericAlertComponent } from '../../components/message-components/alert/generic-alert/generic-alert.component';
import { randomID } from '../../utils/utils';
import { MessageManagerMessageTypeEnum } from '../messages/message.manager.service';

@Injectable({
  providedIn: 'root',
})
export class AlertManagerService {
  genericMessageRefContainer!: ViewContainerRef;

  notifyClosingAlert: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  alertInstanced: GenericAlertComponent[] = [];

  showAlert(el: GenericAlertComponent) {
    setTimeout(() => {
      this.alertInstanced.push(el);
    }, 0);
  }

  closeAlert(el: GenericAlertComponent) {
    setTimeout(() => {
      el.closeAlert();
      this.alertInstanced.pop();
    }, 0);
  }

  closeAlertAfter(el: GenericAlertComponent, ms: number) {
    setTimeout(() => {
      el.closeAlertAfter(ms);
      this.alertInstanced.pop();
    }, 0);
  }

  createAlert(
    message: string,
    title: string = '',
    type: MessageManagerMessageTypeEnum = MessageManagerMessageTypeEnum.INFO,
    viewRef: ViewContainerRef | undefined = undefined,
    extraInfo: string = '',
    seeMultiAlert: boolean = false,
    dismissable: boolean = true,
    dismissTime: number | undefined = undefined,
    hide: boolean = false,
    filterDuplicates: boolean = false
  ) {
    if ((this.alertInstanced.length == 0 && !seeMultiAlert) || seeMultiAlert) {
      const alertConfig: IGenericAlert = {
        id: randomID(),
        title: title,
        message: message,
        type: type,
        dismissable: dismissable,
        dismissTime: dismissTime,
        extraInfo: extraInfo,
        hide: hide,
      } as IGenericAlert;
      if (
        !filterDuplicates ||
        (filterDuplicates &&
          !this.alertInstanced.some(
            (x) => x.configAlert.message == alertConfig.message
          ))
      ) {
        const instanceAlert: ComponentRef<GenericAlertComponent> = viewRef
          ? viewRef.createComponent(GenericAlertComponent)
          : this.genericMessageRefContainer.createComponent(
              GenericAlertComponent
            );
        instanceAlert.instance.configAlert = alertConfig;
        setTimeout(() => {
          this.showAlert(instanceAlert.instance);

          if (!viewRef) {
            window.scrollTo(0, 0);
          }
          if (seeMultiAlert) {
            this.notifyClosingAlert.next(true);
          }
          const sub: Subscription = instanceAlert.instance.closeEvent
            .pipe(finalize(() => sub.unsubscribe()))
            .subscribe((closed: boolean) => {
              if (closed) {
                instanceAlert.destroy();
                this.alertInstanced.pop();
                if (!seeMultiAlert) {
                  this.notifyClosingAlert.next(true);
                }
              }
            });
        }, 0);
      } else {
        setTimeout(() => {
          this.notifyClosingAlert.next(true);
        }, 0);
      }
    }
  }

  closeAllAlerts() {
    this.alertInstanced.forEach((x) =>
      setTimeout(() => {
        x.closeAlert();
      }, 0)
    );
  }
}
